/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DigiticketsEvent } from './DigiticketsEvent';
import {
    DigiticketsEventFromJSON,
    DigiticketsEventFromJSONTyped,
    DigiticketsEventToJSON,
    DigiticketsEventToJSONTyped,
} from './DigiticketsEvent';

/**
 * 
 * @export
 * @interface DigiticketsSession
 */
export interface DigiticketsSession {
    /**
     * 
     * @type {number}
     * @memberof DigiticketsSession
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof DigiticketsSession
     */
    startsAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof DigiticketsSession
     */
    endsAt: Date;
    /**
     * 
     * @type {number}
     * @memberof DigiticketsSession
     */
    spacesSold: number;
    /**
     * 
     * @type {number}
     * @memberof DigiticketsSession
     */
    capacity: number;
    /**
     * 
     * @type {number}
     * @memberof DigiticketsSession
     */
    orderCount: number;
    /**
     * 
     * @type {DigiticketsEvent}
     * @memberof DigiticketsSession
     */
    event?: DigiticketsEvent;
}

/**
 * Check if a given object implements the DigiticketsSession interface.
 */
export function instanceOfDigiticketsSession(value: object): value is DigiticketsSession {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('startsAt' in value) || value['startsAt'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    if (!('spacesSold' in value) || value['spacesSold'] === undefined) return false;
    if (!('capacity' in value) || value['capacity'] === undefined) return false;
    if (!('orderCount' in value) || value['orderCount'] === undefined) return false;
    return true;
}

export function DigiticketsSessionFromJSON(json: any): DigiticketsSession {
    return DigiticketsSessionFromJSONTyped(json, false);
}

export function DigiticketsSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigiticketsSession {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'startsAt': (new Date(json['startsAt'])),
        'endsAt': (new Date(json['endsAt'])),
        'spacesSold': json['spacesSold'],
        'capacity': json['capacity'],
        'orderCount': json['orderCount'],
        'event': json['event'] == null ? undefined : DigiticketsEventFromJSON(json['event']),
    };
}

  export function DigiticketsSessionToJSON(json: any): DigiticketsSession {
      return DigiticketsSessionToJSONTyped(json, false);
  }

  export function DigiticketsSessionToJSONTyped(value?: DigiticketsSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'startsAt': ((value['startsAt']).toISOString()),
        'endsAt': ((value['endsAt']).toISOString()),
        'spacesSold': value['spacesSold'],
        'capacity': value['capacity'],
        'orderCount': value['orderCount'],
        'event': DigiticketsEventToJSON(value['event']),
    };
}

